import React, {PropsWithChildren} from "react";

import {NotificationsContext} from "./notifications-context";

import "./notifications-outlet.scss";

export interface NotificationsOutletProps {
  targetRef: (node: HTMLDivElement|undefined|null) => void,
  target: HTMLDivElement|undefined|null,
}
function NotificationsOutlet(props: PropsWithChildren<NotificationsOutletProps>) {
  return (
    <NotificationsContext.Provider value={{ target: props.target }}>
      {props.children}
      <div id="notifications" ref={props.targetRef}></div>
    </NotificationsContext.Provider>
  );
}
export default NotificationsOutlet;
